import React from 'react';

import { OhsCusvalType } from 'global-components/form/cusvals/OhsCusvalModel';
import OhsSysFieldCusvalGroup from 'global-components/form/sys-fields/OhsSysFieldCusvalGroup';
import { OhsFormLayoutType, OhsFormSettings } from 'global-components/form/services/OhsFormModels';

function SysFieldCusvalGroupFixedValue() {
  const ohsFormSettings = new OhsFormSettings({}, OhsFormLayoutType.AngularPageForm);
  return (
    <OhsSysFieldCusvalGroup
      templateId="6848f649d447960b412a1b64"
      recordId=""
      id="test-id"
      ohsFormSettings={ohsFormSettings}
      cusvalConfig={[
        {
          _id: 'An7R0c67U7',
          type: OhsCusvalType.Text,
          title: 'Reported By',
          required: true,
        },
        {
          _id: 'zFuf6jsrN',
          type: OhsCusvalType.Text,
          description: 'details about the position',
          title: 'Position',
          required: false,
        },
        {
          _id: 'kL9pQ2xwV',
          type: OhsCusvalType.Email,
          description: 'email address',
          title: 'Email Id',
          required: false,
        },
        {
          _id: 'bT4mY8eZq',
          type: OhsCusvalType.Date,
          description: 'Reported date',
          title: 'Reported date',
          required: false,
        },
        {
          _id: 'sJ1vN5aXc',
          type: OhsCusvalType.Date,
          description: 'Occurrence date',
          title: 'Occurrence date',
          required: false,
        },
      ]}
      sysFieldConfig={[
        {
          _id: '685d427567100a46d7a89311',
          type: 'core.module.sysfield',
          fieldType: 'linked_value',
          name: 'Assigned To',
          required: true,
        },
        {
          _id: '685d419122050b8fe2e44160',
          type: 'core.module.sysfield',
          fieldType: 'multi_select',
          name: 'Tags',
          required: true,
        },
        {
          _id: '685d414922050b8fe2e4415f',
          type: 'core.module.sysfield',
          fieldType: 'single_select',
          name: 'Status',
          required: true,
        },
        {
          _id: '685cb71a5a9a960165c213ba',
          type: 'core.module.sysfield',
          fieldType: 'single_select',
          name: 'Test',
          required: true,
        },
      ]}
      layout={[
        'An7R0c67U7',
        'bT4mY8eZq',
        '685d427567100a46d7a89311',
        '685d419122050b8fe2e44160',
        '685d414922050b8fe2e4415f',
        '685cb71a5a9a960165c213ba',
        'zFuf6jsrN',
        'kL9pQ2xwV',
        'sJ1vN5aXc',
      ]}
    />
  );
}

export default SysFieldCusvalGroupFixedValue;
